import { render, staticRenderFns } from "./RfqCardSkeleton.vue?vue&type=template&id=21939a4f&"
import script from "./RfqCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./RfqCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports